import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  payback: {
    list: [],
    view: {},
    types: {},
    walletInfo: {},
    listLoading: false,
    viewLoading: false,
  },
};

export const mutations = {
  PAYBACK_SET_LIST(state, list) {
    state.payback.list = list;
  },
  PAYBACK_SET_LIST_LOADING(state, isLoading) {
    state.payback.listLoading = isLoading;
  },
  PAYBACK_SET_VIEW(state, view) {
    state.payback.view = view;
  },
  PAYBACK_SET_VIEW_LOADING(state, isLoading) {
    state.payback.viewLoading = isLoading;
  },
  PAYBACK_SET_TYPES(state, types) {
    state.payback.types = types;
  },
  PAYBACK_SET_WALLET_INFO(state, walletInfo) {
    state.payback.walletInfo = walletInfo;
  },
};

export const getters = {
  getPaybackList: state => state.payback.list,
  getPaybackView: state => state.payback.view,
  getPaybackTypes: state => state.payback.types,
  getPaybackWalletInfo: state => state.payback.walletInfo,
};

export const actions = {
  fetchPatPaybackList({ commit }, payload) {
    commit('PAYBACK_SET_LIST_LOADING', true);

    const params = {};
    if (payload && payload.status && payload.status !== 'open') {
      params.status = payload.status;
    }

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/payouts`, { params })
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          commit('PAYBACK_SET_LIST_LOADING', false);
          commit('PAYBACK_SET_LIST', response);
        });
      })
      .catch((err) => {
        commit('PAYBACK_SET_LIST_LOADING', false);
        commit('PAYBACK_SET_LIST', []);

        return Promise.reject(err.response && err.response.data ? err.response.data : err);
      });
  },
  fetchPatPaybackView({ commit }, payoutId) {
    commit('PAYBACK_SET_VIEW_LOADING', true);
    commit('PAYBACK_SET_VIEW', {});

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/${payoutId}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          commit('PAYBACK_SET_VIEW_LOADING', false);
          commit('PAYBACK_SET_VIEW', response);
        });
      })
      .catch((err) => {
        commit('PAYBACK_SET_VIEW_LOADING', false);
        commit('PAYBACK_SET_VIEW', []);

        return Promise.reject(err.response && err.response.data ? err.response.data : err);
      });
  },
  fetchPatPaybacksAll({ dispatch }, payload) {
    return dispatch('fetchPatPaybackList', payload).catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err));
  },
  fetchPatPaybackTypes({ commit }) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/types`)
      .then(({ data }) => {
        commit('PAYBACK_SET_TYPES', data);

        return data.data;
      })
      .catch((err) => {
        commit('PAYBACK_SET_TYPES', {});

        return Promise.reject(err.response && err.response.data ? err.response.data : err);
      });
  },
  fetchPatPaybackWalletInfo({ commit }, walletId) {
    commit('PAYBACK_SET_WALLET_INFO', {});

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES_2}/wallet/info/${walletId}`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          commit('PAYBACK_SET_WALLET_INFO', response);
        });
      })
      .catch((err) => {
        commit('PAYBACK_SET_WALLET_INFO', []);

        return Promise.reject(err.response && err.response.data ? err.response.data : err);
      });
  },
  confirmPatPayoutPayback({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/confirm/${payoutId}`)
      .then(data => data).catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err));
  },
  approvePatPayoutPayback({ dispatch }, payoutId) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/approve/${payoutId}`)
      .then(data => data).catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err));
  },
  changePaymentProviderPatPayback({ dispatch }, { payoutId, payload }) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/paymentProvider/${payoutId}`, payload)
      .then(data => data).catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err));
  },
  rollbackPatPayback({ dispatch }, { payoutId, payload }) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES_2}/paybacks/rollback/${payoutId}`, payload)
      .then(data => data).catch(err => Promise.reject(err.response && err.response.data ? err.response.data : err));
  },
};

const payback = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default payback;



// WEBPACK FOOTER //
// ./src/store/payout/payback.js